import React, { useState } from 'react'
import './header.scss'
import logoCompaign from '../../../assets/images/logo-campaign.svg'
import ShoppingCar from '../../atoms/shopping-car/shoppingCar'
import ButtonBars from '../../atoms/buttonBars/buttonBars'

const Header = () => {
  const [open, setOpen] = useState(false)

  const handleClick = () => {
    setOpen(!open)
  }

  return (
    <>
      <header>
        <nav className="f-container">
          <a href="/">
            <img
              className="f-container__logo"
              src={logoCompaign}
              alt="logo header campaña"
            />
          </a>
          <section
            className={`f-container__nav-items ${open ? 'mostrar' : ''}`}
          >
            <ul>
              <li>
                <a
                  onClick={() => {
                    setTimeout(handleClick, 3000)
                    try {
                      window.dataLayer.push({
                        event: 'ga_event',
                        category: 'ui :: landing :: menu',
                        action: 'click',
                        label: 'beneficios',
                        value: '',
                      })
                    } catch (error) {
                      console.log(error)
                    }
                  }}
                  href="#beneficios"
                >
                  Beneficios
                </a>
              </li>
              <li>
                <a
                  onClick={() => {
                    setTimeout(handleClick, 3000)
                    try {
                      window.dataLayer.push({
                        event: 'ga_event',
                        category: 'ui :: landing :: menu',
                        action: 'click',
                        label: 'como las usas',
                        value: '',
                      })
                    } catch (error) {
                      console.log(error)
                    }
                  }}
                  href="#comolausas"
                >
                  ¿Cómo lo usas?
                </a>
              </li>
              <li>
                <a
                  onClick={() => {
                    setTimeout(handleClick, 3000)
                    try {
                      window.dataLayer.push({
                        event: 'ga_event',
                        category: 'ui :: landing :: menu',
                        action: 'click',
                        label: 'ver demo',
                        value: '',
                      })
                    } catch (error) {
                      console.log(error)
                    }
                  }}
                  href="#verdemo"
                >
                  Ver demo
                </a>
              </li>
              {/* <li>
                <a
                  onClick={() => {
                    setTimeout(handleClick, 3000)
                    try {
                      window.dataLayer.push({
                        event: 'ga_event',
                        category: 'ui :: landing :: menu',
                        action: 'click',
                        label: 'experiencia 360',
                        value: '',
                      })
                    } catch (error) {
                      console.log(error)
                    }
                  }}
                  href="#experiencia360"
                >
                  Experiencia 360º
                </a>
              </li> */}
              {['es-CO', 'es-CL', 'es-EC'].includes(process.env.LOCALE) && (
                <li>
                  <a
                    onClick={() => {
                      setTimeout(handleClick, 3000)
                      try {
                        window.dataLayer.push({
                          event: 'ga_event',
                          category: 'ui :: landing :: menu',
                          action: 'click',
                          label: 'concurso',
                          value: '',
                        })
                      } catch (error) {
                        console.log(error)
                      }
                    }}
                    href="#competition"
                  >
                    Participa
                  </a>
                </li>
              )}

              <li>
                <a
                  onClick={() => {
                    setTimeout(handleClick, 3000)
                    try {
                      window.dataLayer.push({
                        event: 'ga_event',
                        category: 'ui :: landing :: menu',
                        action: 'click',
                        label: 'faqs',
                        value: '',
                      })
                    } catch (error) {
                      console.log(error)
                    }
                  }}
                  href="#preguntasfrecuentes"
                >
                  Preguntas Frecuentes
                </a>
              </li>
            </ul>
          </section>
        </nav>
      </header>

      <ButtonBars open={open} handleClick={handleClick} />
      {!['es-PE', 'es-DO', 'es-EC'].includes(process.env.LOCALE) && (
        <ShoppingCar />
      )}
    </>
  )
}

export default Header
